'use client';
import MarkDownParser from '@/components/markdown/content';
import View from '@/components/view';
import { Card, CardBody } from '@nextui-org/react';

type Props = {
  content: any;
};

const ContentCard = ({ content }: Props) => {
  return (
    <Card radius="none" className="py-8 bg-opacity-50">
      <CardBody>
        <View className="section">
          <MarkDownParser content={content} />
        </View>
      </CardBody>
    </Card>
  );
};

export default ContentCard;
